<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-toolbar flat color="transparent">
          <v-toolbar-title
            ><h3>Productos de la sucursal</h3></v-toolbar-title
          >

          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center">
          <v-col cols="12">
            <v-row justify="center">
              <v-col cols="12" md="6">
                <producto-buscador
                  :usarProductoEmpresa="false"
                  @process-buscador-producto="goToBuscador"
                  @process-buscador-producto-select="goToBuscador"
                ></producto-buscador>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-tabs v-model="currentItem" background-color="transparent">
                  <v-tab :to="{ name: 'pos.productos.home' }">
                    Mis productos
                  </v-tab>
                  <v-tab
                    :to="{
                      name: 'pos.productos.inventario',
                      query: { ...$route.query },
                    }"
                  >
                    Inventario
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col>
                <ProductosSucursalFiltros
                  :withTags="false"
                ></ProductosSucursalFiltros>
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <router-view />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
    
  <script>
import { mapActions, mapState, mapMutations } from "vuex";

import ProductosFiltros from "@/components/producto/filtros/productos.filtros.vue";
import ProductosFiltrosTag from "@/components/producto/filtros/productos.filtros.tag.vue";
import ProductoBuscador from "@/components/producto/buscador/producto.buscador.vue";
import ProductosSucursalFiltros from "@/components/producto/filtros/ProductosSucursalFiltros.vue";
import ProductoBuscadorMultiple from "@/components/producto/buscador/producto.buscador.multiple";


export default {
  name: "SucursalProductosLayout",
  components: {
    ProductoBuscador,
    ProductosFiltros,
    ProductosSucursalFiltros,
    ProductosFiltrosTag,
    ProductoBuscadorMultiple

  },

  $_veeValidate: {
    validator: "new",
  },

  data() {
    return {
      currentItem: "",
      producto: null,
    };
  },
  computed: {
    ...mapState("productos", ["paginacion_productos_admin", "productos_admin"]),
  },

  methods: {
    add_query_category_if_exists() {
      var last_navigation = null;
      if (this.navigation.length > 1) {
        last_navigation = this.navigation[this.navigation.length - 1];
        this.add_query_url({ categoria: last_navigation.text });
      }
    },
    seleccionarProducto(producto) {
      alert("Haz seleccionado el producto");
    },
    setProductosSelected(productos) {
      alert("seleccionaste producto");
    },
    get_text_transform(str) {
      if (typeof str === "string") {
        return str.match(/[^ ]+/g).join("-");
      } else {
        return str;
      }
    },
    add_query_url(value) {
      var querys = this.$route.query;

      for (const property in value) {
        var name = value[property];
        value[property] = this.get_text_transform(name);
        querys = Object.assign({}, querys, value);
      }
      this.$router.replace({ query: querys }).catch((error) => {
        if (error.name !== "NavigationDuplicated") {
          throw error;
        }
      });
    },
    get_params_query() {
      var array = [];
      var params = this.$route.params;
      if (params && params.categoria) {
        var object = {
          value: null,
          key: "",
        };
        object.value = params.categoria;
        object.key = "categoria";
        array.push(object);
      }

      var querys = this.$route.query;
      if (Object.keys(querys).length !== 0) {
        for (const property in querys) {
          var object = {
            nombre: null,
            key: "",
          };
          object.key = property;
          object.value = this.get_text_transform(querys[property]);
          array.push(object);
        }
      }
      array.push({ key: "global", value: false }); // Reemplaza "valor_global" con lo que necesites

      return array;
    },
    goToBuscador(search) {
      if (search == this.$route.query.q) {
        return;
      }
      const isnum = /^\d+$/.test(search);
      const isBarcode = isnum && search.length > 6;

      if (isBarcode) {
        this.add_query_url({ barcode: search });
      } else {
        this.add_query_url({ q: search });
      }
    },
  },

};
</script>
    
  <style scoped>

</style>
    